import React, { useContext, useEffect, useState } from "react";
import { ConfigContext } from "../Context/ConfigContext";
import axios from "axios";
import CryptoJS from "crypto-js";
import LazyImage from "../Components/LazyImage";
import { NavLink, Link, useNavigate } from "react-router-dom";


const HeaderTemp = () => {
  const { apiURL, apiHeaderFile, apiHeaderJSON, setCompanyName,permissions,setPermissions } = useContext(ConfigContext);
  const navigate = useNavigate();
  const [modules, setModules] = useState([]);
  const [companyData, setCompanyData] = useState({});
  const [logoData, setLogoData] = useState({});
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [allPages, setAllPages] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const handleLogout = () => {
    localStorage.removeItem("token_erp");
    localStorage.removeItem("user_id_erp");
    localStorage.removeItem("company_id_erp");
    localStorage.setItem("reset",true);
    window.location.href = "/";
  };

  // const navigate = useNavigate();
  
    // const handleNavigation = () => {
    //   navigate('/AdminBasicDetails');
    // };
  // const findMatchingRoutes = (response, routes) => {
  //   const matchedRoutes = [];
  
  //   const checkPathMatch = (modules, routes) => {
  //     for (const module of modules) {
  //       if (module.path) {
  //         const match = routes.find((route) => route.path.includes(module.path));
  //         if (match) {
  //           matchedRoutes.push(match);
  //         }
  //       }
  
  //       // Recursively check for sub_modules
  //       if (module.sub_module) {
  //         checkPathMatch(module.sub_module, routes);
  //       }
  //     }
  //   };
  
  //   checkPathMatch(response, routes);
  
  //   return matchedRoutes;
  // };
  
  const getList = () => {
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetHeaderPermissionList`, {
        params: {},
        headers,
      })
      .then((response) => {
        let data = response.data;
        // console.log(data);
        if (response.data.success === true) {
          setModules(data?.result);
          setPermissions(data?.result);
        } else {
          console.error("Error fetching list");
        }
      })
      .catch(function (error) {
        console.log("error", error);
      });
  };

  useEffect(() => {
    getList();
  }, []);

  const getCompanyData = () => {
    setLoading(true);
    let options = {
      url: `${apiURL}Employees/CompanyUserDetails?limit=${limit}&page=${page}`,
      method: "GET",
      headers: apiHeaderJSON,
    };
    axios(options)
      .then((response) => {
        // console.log("getEmployeeOnboardingData ~ response", response?.data);
        let res = response?.data;
        if (response.data.success === true) {
          console.log("getCompanyData ~ res", res);
          localStorage.setItem("company_code",res?.data[0]?.company_code);
          setCompanyName(res?.data[0]?.company_user_name);
          setCompanyData(res?.data[0]);
          setPage(res?.page);
          setAllPages(res?.total_pages);
          setTotalRecords(parseInt(res?.total_records));
          setLogoData(res?.logo_data[0]);
        } else if (response.data.success === false) {
        }

        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });
  };
  useEffect(() => {
    getCompanyData();
  }, []);

  // const [modules, setModules] = useState([
  //     {
  //         name: "Dashboard",
  //         path: "/",
  //     },
  //     {
  //         name: "Employee Management",
  //         path: "/",
  //         sub_module: [
  //             {
  //                 name: "Guest Employee",
  //                 path: "",
  //                 sub_module: [
  //                     {
  //                         name: "Guest Employee",
  //                         path: "GuestEmployee",
  //                     },
  //                     {
  //                         name: "Employee List",
  //                         path: "CandidateDetailsList",
  //                     },
  //                     {
  //                         name: "Document Verification",
  //                         path: "DocumentVerification",
  //                     },
  //                     {
  //                         name: "Letters",
  //                         path: "Letters",
  //                     },
  //                     {
  //                         name: "Employee Status",
  //                         path: "EmployeeStatus",
  //                     },
  //                     {
  //                         name: "Background Verification",
  //                         path: "BackgroundVerification",
  //                     },
  //                     {
  //                         name: "Background Verified",
  //                         path: "BackgroundVerified",
  //                     },
  //                     {
  //                         name: "Assign Shifts",
  //                         path: "AssignShiftes",
  //                     },
  //                     {
  //                         name: "Assign RM",
  //                         path: "AssignRM",
  //                     },
  //                 ]
  //             },
  //             {
  //                 name: "Employee Onboarding",
  //                 path: "",
  //                 sub_module: [
  //                     {
  //                         name: "Onboarding",
  //                         path: "EmployeeOnboarding",
  //                     },
  //                 ]
  //             },
  //             {
  //                 name: "Employee Enrollment",
  //                 path: "",
  //                 sub_module: [
  //                     {
  //                         name: "Approved Employees",
  //                         path: "ApprovedEmployees",
  //                     },
  //                 ]
  //             },
  //         ]
  //     },
  //     {
  //         name: "Letter Management",
  //         path: "/",
  //         sub_module: [
  //             {
  //                 name: "New Letter",
  //                 path: "NewLetter",

  //             },
  //             {
  //                 name: "Letter List",
  //                 path: "LetterList",
  //             },
  //         ]
  //     },
  //     {
  //         name: "Payroll",
  //         path: "/",
  //         sub_module: [
  //             {
  //                 name: "Settings",
  //                 path: "",
  //                 sub_module: [
  //                     {
  //                         name: "Payroll Settings",
  //                         path: "PayrollGeneralSettings",
  //                     },
  //                     {
  //                         name: "Payroll Head",
  //                         path: "PayrollHeadMaster",
  //                     },
  //                     {
  //                         name: "Statutory Slab Master",
  //                         path: "StatutorySlabMaster",
  //                     },
  //                 ]
  //             },
  //             {
  //                 name: "Lock Attendance And Leave",
  //                 path: "LockAttendanceAndLeave",
  //             },
  //             {
  //                 name: "Payroll import",
  //                 path: "",
  //                 sub_module: [
  //                     {
  //                         name: "Payroll Attendance",
  //                         path: "PayrollAttendance",
  //                     },
  //                     {
  //                         name: "Payroll Other Head Import",
  //                         path: "PayrollOtherHeadImport",
  //                     },
  //                     {
  //                         name: "Payroll Other Head Screen",
  //                         path: "PayrollOtherHeadInput",
  //                     },
  //                 ]
  //             },
  //             {
  //                 name: "Payroll Process",
  //                 path: "PayrollProcess",
  //             },
  //         ]
  //     },
  //     {
  //         name: "Masters",
  //         path: "",
  //         sub_module: [
  //             {
  //                 name: "Header Master",
  //                 path: "HeaderMaster"
  //             }
  //         ]
  //     },
  // ]);
  // const [isOpen, setIsOpen] = useState(false); // Manage open state for each module

  // const toggleDropdown = () => setIsOpen(!isOpen);
  // const closeDropdown = () => setIsOpen(false); 

  // console.log("REACT_APP_SECRET_KEY",process.env.REACT_APP_SECRET_KEY);

  const handleNavigate = (path,data) => {
    setIsMenuOpen(false);
    const queryData = data;
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(queryData),process.env.REACT_APP_SECRET_KEY).toString();
    const encodedQuery = encodeURIComponent(encryptedData);
    if(data){
      navigate(`${path}?abs=${encodedQuery}`);
    }
    else{
      navigate(`${path}`);
    }
    
  };

  const renderModules = (modules) => {
    return modules.map((module, index) => (
      <li key={index} className="nav-item">
        <span
          onClick={()=> module?.path && handleNavigate(module?.path,module?.id)}
          style={{ padding: "0.5rem 1rem", color: "gray" }} // Set default color to gray
          className="nav-link menu-link"
          data-bs-toggle={module.sub_module ? "collapse" : undefined}
          role="button"
          aria-expanded="false"
          aria-controls={`sidebar-${index}`}
          activeClassName="active-link" 
        >
          <span
            style={{ fontSize: "0.8rem" }}
            className="link-text"
            data-key="t-apps"
          >
            {module.name}
          </span>
        </span>

        {/* Check if the module has sub-modules */}
        {module.sub_module && module.sub_module?.length > 0 && (
          <div className="collapse menu-dropdown" id={`sidebar-${index}`}>
            <ul
              style={{ fontSize: "0.8rem", marginRight: "0.2rem"}}
              className="nav nav-md flex-column"
            >
              {renderModules(module.sub_module)}
            </ul>
          </div>
        )}
      </li>
    ));
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {console.log(isMenuOpen); setIsMenuOpen(!isMenuOpen);}
  const [activeHeaderId, setActiveHeaderId] = useState(null);
  const [openStates, setOpenStates] = useState({});
  useEffect(()=>{
    console.log("activeHeaderId ===>>",activeHeaderId);
  },[activeHeaderId]);
  const renderMobileModules = (modules, parentIndex = '', openStates, setOpenStates, level = 0) => {
    return modules.map((module, index) => {
      const currentIndex = `${parentIndex}${index}`;
      // console.log("name", module?.name);
      // console.log("module.sub_module length", module.sub_module);
      const hasChildren = module.sub_module && module.sub_module.length > 0;
      const isOpen = openStates[currentIndex] || false;
  
      const toggleCollapse = () => {
        setOpenStates((prev) => ({
          ...prev,
          [currentIndex]: !prev[currentIndex]
        }));
      };
  
      return (
        <li key={currentIndex} className="nav-item">
          <div
            className={`nav-link custom-menu-link ${hasChildren ? "has-children" : ""} ${
              module.path && activeHeaderId === module.id ? "active-module" : ""
            }`}
            onClick={() => {
              // console.log("hasChildren",hasChildren);
              if (hasChildren) {
                toggleCollapse();
              }
              if (module.path) {
                setActiveHeaderId(module.id);
                handleNavigate(module.path, module.id);
              }
            }}
          >
            {/* <i className={`ri-arrow-right-s-line`} /> */}
            {/* <span className={`arrow ${isOpen ? "rotate" : ""}`}>
                <i className={`ri-arrow-right-s-line`} />
              </span> */}
            <span>{module.name}</span>
            {hasChildren && (
              <span className={`arrow ${isOpen ? "rotate" : ""}`}>&#9656;</span>
              // <span style={{ height: "0.5rem", width: "0.5rem" }} className={`arrow ${isOpen ? "rotate" : ""}`}>
              //   <i className={`ri-arrow-right-s-line`} />
              // </span>
            )}
          </div>
  
          {hasChildren && (
            <div className={`custom-collapse level-${level} ${isOpen ? "open" : ""}`}>
              <ul className="nav nav-sm flex-column">
                {renderMobileModules(module.sub_module, `${currentIndex}-`, openStates, setOpenStates,level + 1)}
              </ul>
            </div>
          )}
        </li>
      );
    });
  };
  

  if (loading) {
    return <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
              <div className="text-center">
                  <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                  </div>
              </div>
            </div>;
  }
  
  return (
    <>
      <header id="page-topbar">
         <div className={`app-menu-mob navbar-menu-mob ${isMenuOpen ? 'menu-open' : ''} mt-0 ps-0`} style={{ paddingRight: "5rem" }}>
          <div className="h-100 d-flex flex-column bg-white">
            {/* Fixed top section */}
            <div className="pe-3 py-2 sticky-top bg-white z-2 border-bottom">
              <button type="button" style={{ height: "2rem" }} className="btn btn-sm fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" onClick={toggleMenu} id="topnav-hamburger-icon">
                <i className="ri-arrow-left-line fs-1" />
              </button>
              <li className="menu-title mt-3"><span data-key="t-menu">Menu</span></li>
            </div>
            {/* Scrollable list */}
            <div id="scrollbar" data-simplebar className="flex-grow-1 overflow-auto">
              <ul className="navbar-nav d-flex flex-column" id="navbar-nav">
                {renderMobileModules(modules, '', openStates, setOpenStates)}
              </ul>
            </div>
          </div>
          <div className="sidebar-background" onClick={toggleMenu} />
        </div>
        <div className="layout-width">
          <div style={{ height: "54px"}} className="navbar-header">
            <div className="d-flex align-items-center gap-1">
              <button type="button" className="btn btn-sm px-0 fs-16 header-item vertical-menu-btn topnav-hamburger shadow-none" onClick={toggleMenu} id="topnav-hamburger-icon">
                <span className="hamburger-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </button>
              <div className="navbar-brand-box horizontal-logo p-2">
                {/* <NavLink to="/" className=" logo-dark">
                  <div className="logo-lg d-flex align-items-center gap-1">
                    <div style={{ width: "6rem", maxHeight:"3rem" }} className="logo-lg">
                      <LazyImage src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`} style={{ width: "6rem", maxHeight:"3rem", }} alt="logo" className="logo-img" />
                    </div>
                    <div style={{ width: "6rem", maxHeight:"3rem", overflow: "hidden", }} className="logo-lg">
                      <LazyImage src={logoData?.company_logo_url} style={{ width: "6rem", maxHeight:"3rem", }} alt="Company_logo" className="logo-img" />
                    </div>
                  </div>
                </NavLink> */}
                <NavLink to="/" className="logo-dark d-block d-lg-block">
                  <div className="d-flex align-items-center gap-1">
                    <div className="logo">
                      <LazyImage src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`} style={{ width: "100%", maxHeight: "3rem" }} alt="logo" className="logo-img"/>
                    </div>
                    <div className="logo">
                      <LazyImage src={logoData?.company_logo_url} style={{ width: "100%", maxHeight: "3rem" }} alt="Company_logo" className="logo-img"/>
                    </div>
                  </div>
                </NavLink>
                {/* <NavLink to={"/"} className="logo logo-light">
                  <span className="logo-sm">
                    <LazyImage src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`} style={{ width: "6rem", maxHeight:"3rem", }} alt="logo" className="logo-img" />
                  </span>
                  <span className="logo-lg">
                    <LazyImage src={logoData?.company_logo_url} style={{ width: "6rem", maxHeight:"3rem", }} alt="Company_logo" className="logo-img" />
                  </span>
                </NavLink> */}
              </div>
              <h6 className="d-none d-md-inline-block ms-1 fw-medium user-name-text text-truncate mb-0 fw-semibold"
              style={{ maxWidth: "30rem", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis",}}>
              {logoData?.company_name}
              </h6>
              {/* <button type="button" className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger" id="topnav-hamburger-icon">
                                <span className="hamburger-icon">
                                    <span />
                                    <span />
                                    <span />
                                </span>
                            </button> */}
              {/* <form className="app-search d-none d-md-block">
                                <div className="position-relative mt-3">
                                    <input type="text" className="form-control" placeholder="Search..." autoComplete="off" id="search-options" />
                                    <span className="mdi mdi-magnify search-widget-icon" />
                                    <span className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none" id="search-close-options" />
                                </div>
                            </form> */}
            </div>
            {/* <div className="d-flex align-items-center">
              <h6
                className="d-none d-sm-inline-block ms-1 fw-medium user-name-text text-truncate mb-0 fw-semibold"
                style={{ maxWidth: "20rem", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>
                {logoData?.company_user_name}
              </h6>
              <div className="dropdown ms-sm-3 header-item h-auto topbar-user rounded-3">
                  <button type="button" className="btn p-1" id="page-header-user-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span className="d-flex align-items-center">
                      <LazyImage src={`${logoData?.employee_profile_url || "assets/profile-pic.png"}`} 
                      alt="Company_logo" className="rounded-circle header-profile-user" />
                    </span>
                  </button>
                  <div className="dropdown-menu">
                    
                    <h6 className="dropdown-header">
                    <span className=" d-xl-inline-block ms-1 fw-bold fw-medium user-name-text"
                        style={{ maxWidth: "500px", textWrap: "wrap" }}>
                        {logoData?.employee_code}
                      </span><br/>
                      <div className="dropdown-divider" />
                      <span className=" d-xl-inline-block ms-1 fw-medium user-name-text"
                        style={{ maxWidth: "500px", textWrap: "wrap" }}>
                        {logoData?.company_user_name}
                      </span>
                      
                    </h6>
                    <div className="dropdown-divider" />
                    <button style={{ width:"90%"}} className="dropdown-item m-auto border border-danger rounded-3" onClick={handleLogout}>
                      <i className="mdi mdi-logout text-danger fs-16 align-middle me-1" /> 
                      <span className="align-middle text-danger" data-key="t-logout">Logout</span>
                    </button>
                  </div>
              </div>
            </div> */}
            <div className="d-flex align-items-center">
            <h6 className="d-none d-xl-inline-block ms-1 fw-medium user-name-text text-truncate mb-0 fw-semibold"
              style={{ maxWidth: "14rem", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", }}>
              {companyData?.company_user_name}
            </h6>
              {/* <div className="dropdown d-md-none topbar-head-dropdown header-item">
                <button type="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle" id="page-header-search-dropdown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i className="bx bx-search fs-22" />
                </button>
                <div className="dropdown-menu dropdown-menu-lg dropdown-menu-end p-0" aria-labelledby="page-header-search-dropdown">
                  <form className="p-3">
                    <div className="form-group m-0">
                      <div className="input-group">
                        <input type="text" className="form-control" placeholder="Search ..." aria-label="Recipient's username"/>
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div> */}
              <div className="dropdown ms-sm-3 header-item h-auto topbar-user rounded-3">
                <button
                  type="button"
                  className="btn p-1"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <img
                      className="rounded-circle header-profile-user"
                      src={ companyData?.admin_profile_url || `${process.env.REACT_APP_BASE_URL}assets/Image.jpg`}
                      alt="Header Avatar"
                    />
                    {/* <span style={{maxWidth:"7rem"}} className="text-start ms-xl-2">
                        <span 
                          className="d-none d-xl-inline-block ms-1 fw-medium user-name-text text-truncate mb-0 fw-semibold"
                          style={{
                            maxWidth: "7rem", 
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis"}}>{companyData?.company_user_name}</span>
                        <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">Profile</span>
                    </span> */}
                  </span>
                </button>
                {/* <div className="dropdown ms-sm-3 header-item h-auto topbar-user rounded-3"> */}
                  
                  {/* <h6 className=" px-2">Welcome!</h6>
                  <div className="dropdown-divider" />
                  <h6 style={{color:"black"}} className="dropdown-header">{companyData?.company_user_name}</h6>
                  <div className="dropdown-divider" /> */}
                  <div className="dropdown-menu">
                   <div className="dropdown-divider" />
                    {/* <h6 className="dropdown-header"> */}
                   
                {/* <div className="flex-grow-1 ms-3 cursor-pointer hover-effect" onClick={handleNavigation}>
                     </div> */}
                      <NavLink to="/AdminBasicDetails">

                      
                      <div className=" w-full ms-1 ps-2 fw-medium user-name-text cursorPointer"
                        style={{ textWrap: "wrap" }}>
                        {/* {companyData?.company_user_name} */}
                        Profile
                      </div>
                      </NavLink>
                      
                    {/* </h6> */}
                    <div className="dropdown-divider" />
                  <button style={{ width:"90%"}} className="dropdown-item m-auto border border-danger rounded-3" onClick={handleLogout}>
                    <i className="mdi mdi-logout text-danger fs-16 align-middle me-1" />
                    <span className="align-middle text-danger" data-key="t-logout">
                      Logout
                    </span>
                  </button>
                  
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div
        id="removeNotificationModal"
        className="modal fade zoomIn"
        tabIndex={-1}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="NotificationModalbtn-close"
              />
            </div>
            <div className="modal-body">
              <div className="mt-2 text-center">
                <lord-icon
                  src="https://cdn.lordicon.com/gsqxdxog.json"
                  trigger="loop"
                  colors="primary:#f7b84b,secondary:#f06548"
                  style={{ width: "100px", height: "100px" }}
                />
                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                  <h4>Are you sure ?</h4>
                  <p className="text-muted mx-4 mb-0">
                    Are you sure you want to remove this Notification ?
                  </p>
                </div>
              </div>
              <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                <button
                  type="button"
                  className="btn w-sm btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn w-sm btn-danger"
                  id="delete-notification"
                >
                  Yes, Delete It!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginTop: "54px"}} className="app-menu navbar-menu">
        {/* <div className="navbar-brand-box">
          <NavLink to={"/"} className="logo logo-dark">
            <span className="logo-sm">
              <img
                src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-sm.png`}
                alt=""
                height={22}
              />
            </span>
            <span className="logo-lg">
              <img
                src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-dark.png`}
                alt=""
                height={17}
              />
            </span>
          </NavLink>
          <NavLink to={"/"} className="logo logo-light">
            <span className="logo-sm">
              <img
                src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-sm.png`}
                alt=""
                height={22}
              />
            </span>
            <span className="logo-lg">
              <img
                src={`${process.env.REACT_APP_BASE_URL}assets/images/logo-light.png`}
                alt=""
                height={17}
              />
            </span>
          </NavLink>
          <button
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-line" />
          </button>
        </div> */}
        <div id="scrollbar">
          <div style={{ maxWidth: "90%" }} className=" m-auto">
            <div id="two-column-menu"></div>
            <ul
              className="d-flex gap-3 align-items-center flex-wrap navbar-nav flex-md-row"
              id="navbar-nav"
            >
              <li className="menu-title">
                <span data-key="t-menu">Menu</span>
              </li>
              {renderModules(modules)}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderTemp;
